import React from 'react'
import Title from 'Components/Title'
import DatePicker from 'Components/DatePicker'
import moment from 'moment'

moment.locale('fr')

/*
 + ': ' + moment()
      .year(this.props.data !== undefined && this.props.data.annee || 1900)
      .month(this.props.data !== undefined && this.props.data.mois && (this.props.data.mois -1)+'' || 0)
      .date(this.props.data !== undefined && this.props.data.jour || 1).format('dddd LL')
*/

export default class Date extends React.Component {
  constructor (props) {
    super(props)
  }

  handleChange = (date) => {
    this.props.onChangeFormulaire('jour', moment(date).date())
    this.props.onChangeFormulaire('mois', moment(date).month() + 1)
    this.props.onChangeFormulaire('annee', moment(date).year())
  }

  render () {
    return (<Title inline={this.props.inline} title={this.props.title}>
        <DatePicker
          //inline
          disabled={this.props.disabled || false}
          onChange={this.handleChange}
          isClearable={!this.props.disabled}
          dateFormat="dddd LL"
          style={{ width: '100%' }}
          selected={moment()
            .year(this.props.data !== undefined && this.props.data.annee || 1900)
            .month(this.props.data !== undefined && this.props.data.mois && (this.props.data.mois - 1) + '' || 0)
            .date(this.props.data !== undefined && this.props.data.jour || 1)}
          minDate={moment().year(1900).month(0).date(1)}
          maxDate={moment()}
          showDisabledMonthNavigation
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={moment().year() - 1900}
        />
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/Other/Date.js